<template>
  <v-timeline-item
    v-if="result"
    :id="result.id"
    class="timelineItem"
    :color="result.inactive ? 'grey' : stepColor"
    :icon="'mdi-' + stepIcon"
    medium
  >
    <!-- result.type == 1 ? '#2196F3' : '#9c27b0'
result.type == 1 ? '#2196F3' : '#9c27b0' -->
    <v-card
      :color="result.inactive ? 'grey' : stepBorderColor"
      class="step mr-3"
      :elevation="active ? 4 : 0"
      :max-width="stepWidth"
      @mouseenter="prev = true"
      @mouseleave="prev = false"
    >
      <v-scroll-x-transition>
        <v-card
          class="my-3 mr-4 pa-0 prev"
          elevation="4"
          rounded
          v-if="prev && !active && result.image"
          @click="openImage(result.image)"
        >
          <div class="fill-height block">
            <v-icon small color="white">mdi-arrow-expand</v-icon>
          </div>
          <v-img eager cover :src="result.image"> </v-img>
        </v-card>
      </v-scroll-x-transition>
      <v-card-title class="pa-2 pointer">
        <v-row class="fw">
          <v-col v-if="isRoutine" cols="auto" class="pr-1" @click="view">
            <v-icon
              class="lighten-5 iconWrap mt-n2 ml-n1"
              :class="result.inactive ? 'grey' : stepColor"
              :color="result.inactive ? 'grey' : stepColor"
            >
              mdi-{{ stepIcon }}
            </v-icon>
          </v-col>
          <v-col v-else cols="auto" class="pr-1" @click="view">
            <v-icon
              class="lighten-5 iconWrap mt-n2 ml-n1"
              :class="result.inactive ? 'grey' : actionColor"
              :color="result.inactive ? 'grey' : actionColor"
              >mdi-{{ actionIcon }}</v-icon
            >
            <!-- <strong
              class="font-italic font-weight-bold text-uppercase text-body-2 mr-1"
              :class="{
                'purple--text': !result.inactive,
                'grey--text': result.inactive,
              }"
              v-if="
                ['get', 'post', 'put', 'delete'].indexOf(actionMethod) >= 0
              "
            >
              [{{ actionMethod }}]
            </strong>
            <strong>
              {{ result.name }}
            </strong> -->
          </v-col>

          <v-col
            cols="auto"
            class="pl-0 pr-1 pt-4 font-italic font-weight-bold text-center text-uppercase text-caption"
            :class="{
              'purple--text': !result.inactive,
              'grey--text': result.inactive,
            }"
            dark
            v-if="
              ['get', 'post', 'put', 'delete', 'patch'].indexOf(actionMethod) >=
              0
            "
            >[{{ actionMethod }}]
          </v-col>
          <v-col
            class="text-truncate pl-0 pt-2"
            :class="{
              'grey--text': result.inactive,
            }"
            @click="view"
          >
            <strong :title="result.name">{{ result.name }}</strong>
          </v-col>
          <v-col class="pb-0" cols="auto" v-if="!active" @click="view">
            <v-row class="ma-0">
              <!-- <Tooltip
              :content="`Duration: ${timeFormatter(result.duration)}`"
              color="info"
              top
            > -->
              <v-chip
                small
                class="mx-1 pointer fw"
                v-if="'duration' in result && result.duration >= 0"
                :disabled="result.inactive"
                :color="result.inactive ? null : 'info'"
              >
                <v-icon class="mx-1" small fab>mdi-timer-outline</v-icon>
                <strong :class="!result.inactive ? null : ' text--white'">{{
                  timeFormatter(routineParent ? 0 : result.duration)
                }}</strong>
              </v-chip>
              <!-- </Tooltip> -->
            </v-row>
            <v-row class="mx-0 my-1">
              <v-chip
                small
                class="mx-1 pointer fw text--lighten-1"
                v-if="result.success"
                :disabled="result.inactive"
                :color="result.inactive ? null : 'success'"
              >
                <v-icon class="mx-1" small fab> mdi-thumb-up </v-icon>
                <strong> Passed </strong>
              </v-chip>

              <v-chip
                v-if="!result.success && !result.inactive"
                color="red"
                class="mx-1 pointer fw"
                small
                dark
              >
                <v-icon label="Failed" class="mx-1" small fab>
                  mdi-thumb-down
                </v-icon>
                <strong> Failed</strong>
              </v-chip>
            </v-row>
          </v-col>
          <v-col cols="auto py-0" v-if="result.inactive">
            <v-icon color="grey" small>mdi-connection</v-icon>
          </v-col>
          <!-- <v-col
            cols="2"
            class="my-3 mr-4 pa-0 thumb "
            v-if="!active && result.image"
            @click="openImage(result.image)"
          >
            <div class="fill-height block">
              <v-icon small color="white">mdi-arrow-expand</v-icon>
            </div>
            <v-img eager :lazy-src="result.image" :src="result.image"> </v-img>
          </v-col> -->
          <!--</v-col>
             <v-col v-if="!active" cols="auto" @click="view">
              <v-btn elevation="0" x-small text color="cyan" >
                Inspect <v-icon label="Review">mdi-magnify</v-icon>
              </v-btn>
            </v-col> -->
        </v-row>
      </v-card-title>
      <v-card-text :class="{ 'py-0': true, 'pb-3': active }">
        <p v-if="result.description && !active" class="ma-0 grey--text">
          {{ result.description }}
        </p>
        <v-row v-if="active" class="grey my-1 lighten-5">
          <v-col cols="7" v-if="!result.inactive" class="scrollable h25">
            <v-list disabled class="trns">
              <v-list-item dense v-if="result.result && result.image">
                <v-list-item-content>
                  <!-- <small class="blue--text" v-html="result.result"></small> -->
                  <p class="blue--text mb-0" v-html="result.result"></p>
                </v-list-item-content>
              </v-list-item>
              <v-list-item dense>
                <v-list-item-content>
                  <v-list-item-title class="body-2">
                    <strong>
                      <v-icon small>mdi-list-status</v-icon> Status:
                    </strong>
                    <strong
                      :class="(result.success ? 'success' : 'red') + '--text'"
                    >
                      <v-icon
                        small
                        :class="{ 'mb-1': result.success }"
                        :color="result.success ? 'success' : 'red'"
                      >
                        mdi-thumb-{{ result.success ? "up" : "down" }}
                      </v-icon>
                      {{ result.success ? "Passed" : "Failed" }}
                    </strong>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item dense v-if="result.description">
                <v-list-item-content>
                  <v-list-item-title class="body-2">
                    <strong>
                      <v-icon small>mdi-text</v-icon> Description:
                    </strong>
                  </v-list-item-title>
                  <p class="ml-3 grey--text">
                    {{ result.description }}
                  </p>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                dense
                v-if="'duration' in result && result.duration >= 0"
              >
                <v-list-item-content>
                  <v-list-item-title class="body-2">
                    <strong>
                      <v-icon small>mdi-timer-outline</v-icon> Duration:
                    </strong>
                    {{ timeFormatter(result.duration) }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item dense v-if="result.device">
                <v-list-item-content>
                  <v-list-item-title class="body-2">
                    <strong>
                      <v-icon small>mdi-devices</v-icon> Device:
                    </strong>
                    {{ result.device }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item dense v-if="result.env">
                <v-list-item-content>
                  <v-list-item-title class="body-2">
                    <strong> <v-icon small>mdi-variable</v-icon> Env: </strong>
                    <v-chip-group active-class="primary--text" column>
                      <v-chip
                        color="blue"
                        dark
                        small
                        v-for="env in result.env"
                        :key="env.name"
                        :title="env.value"
                      >
                        <Tooltip :content="env.value" color="info" top>
                          <strong> {{ env.name }}</strong>
                        </Tooltip>
                      </v-chip>
                    </v-chip-group>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-list class="trns">
              <v-list-item dense v-if="result.logs">
                <v-list-item-content>
                  <v-list-item-title class="body-2">
                    <strong>
                      <v-icon small>mdi-clipboard-list</v-icon> Logs:
                    </strong>

                    <v-btn
                      @click="openResponse(result.logs)"
                      color="blue"
                      centered
                      x-small
                      dark
                    >
                      <v-icon small>mdi-magnify</v-icon>
                      View Logs
                    </v-btn>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
          <v-col cols="5 pa-0" v-if="result.image" class="thumbnail">
            <v-img
              @click="openImage(result.image)"
              eager
              :lazy-src="result.image"
              :src="result.image"
            >
              <div class="fill-height block">
                <v-icon color="white">mdi-arrow-expand</v-icon>
              </div>
              <!-- <div class="block repeating-gradient"></div> -->
            </v-img>
          </v-col>
          <v-col cols="5" v-if="result.type === 0 && !result.inactive">
            <v-row class="justify-center">
              <v-col cols="auto">
                <v-btn
                  @click="openResponse(result.result)"
                  color="blue"
                  centered
                  dark
                >
                  <v-icon small>mdi-magnify</v-icon>
                  View Response
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            class="h25"
            v-if="(result.type === 1 && !result.image) || result.inactive"
          >
            <p v-html="result.result"></p>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pointer pa-1" @click="view">
        <v-icon class="mr-2" v-if="result.waitFor" small> mdi-sleep </v-icon>
        <v-icon
          class="mr-2"
          v-if="result.env && result.env.length"
          small
          :color="result.inactive ? 'grey' : 'teal'"
          title="Environment Variable Active"
        >
          mdi-variable
        </v-icon>
        <v-spacer> </v-spacer>
        <!-- <Tooltip
          :content="`Duration: ${timeFormatter(result.duration)}`"
          color="info"
          top
        >
          <v-chip
            small
            class="mx-1 pointer"
            v-if="'duration' in result && result.duration >= 0"

            color="info"
          >
            <v-icon class="mx-1" small fab>mdi-timer-outline</v-icon>
            <strong>{{ result.duration | timeSymbol }}</strong>
          </v-chip>
        </Tooltip>
        <v-chip
          small
          class="mx-1 pointer"
          v-if="result.success && !result.inactive"

          dark
          color="success"
        >
          <v-icon class="mx-1" small fab>mdi-thumb-up</v-icon>
          <strong> Passed</strong>
        </v-chip>

        <v-chip
          v-if="!result.success && !result.inactive"
          color="red"
          class="mx-1"
          small
          dark
        >
          <v-icon label="Failed" class="mx-1" small fab >
            mdi-thumb-down
          </v-icon>
          <strong> Failed</strong>
        </v-chip> -->
      </v-card-actions>
    </v-card>
    <v-timeline
      v-if="result && result.children && result.children.length"
      align-top
      dense
    >
      <time-line-result
        v-for="(r, i) in result.children"
        :key="r.name + i"
        :result="r"
        :routineParent="isRoutine || routineParent"
        :pos="[...pos, i]"
      />
    </v-timeline>
  </v-timeline-item>
</template>

<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";

import {
  actionIcon,
  actionColor,
  stepIcon,
  statusFailColor,
  stepColor,
  timeFormatter,
  scrollToID,
} from "../utils";
import Tooltip from "@/components/Tooltip.vue";
// import Tooltip from "@/components/Tooltip.vue";

export default Vue.extend({
  name: "time-line-result",
  data() {
    return {
      prev: false,
    };
  },
  props: {
    result: VueTypes.any,
    pos: VueTypes.any,
    routineParent: VueTypes.bool.def(false),
  },
  methods: {
    timeFormatter,
    view(): void {
      if (this.isRoutine) {
        return;
      }
      if (this.active) {
        this.$store.commit("Results/setCurrentResultView");
        this.$store.commit("Plans/setPlanCurrentStep");
      } else {
        this.$store.commit("Plans/setPlanCurrentStep");
        this.$store.commit("Results/setCurrentResultView", this.result);
        // if (this.result.testId) {
        //   this.$store.commit("Plans/setPlanCurrentStep", this.result.testId);
        // }
      }
    },
    openImage(src: string) {
      const { innerHeight, innerWidth } = window;
      const width = Math.min(this.imgMeta.width, innerWidth * 0.8);
      const res = width / this.imgMeta.width;
      const height = Math.min(this.imgMeta.height * res, innerHeight * 0.9);
      this.$store.commit("setSlidesOptions", {
        height,
        width,
      });
      this.$store.commit("setSlides", [src]);
    },
    openResponse(resp: any, type = "html") {
      this.$store.commit("setResponse", resp);
      this.$store.commit("setResponseOptions", { type });
    },
  },
  computed: {
    active(): boolean {
      const activeRes = this.$store.getters["Results/getActiveResult"](
        this.result.id
      );
      const activeTest = this.$store.getters["Plans/getActiveStep"](
        this.result.testId
      );
      return activeRes || activeTest;
    },
    stepWidth():string{
      return this.active ? '600px' : '500px'
    },
    last(): string | undefined {
      return this.$store.getters["Plans/getLastResult"];
    },
    isRoutine(): boolean {
      return this.result.ref ? true : false;
    },
    imgMeta(): any {
      const meta: any = {};
      if (this.result?.image) {
        var img = new Image();
        img.src = this.result?.image;
        const { height, width } = img;
        meta.height = height;
        meta.width = width;
      }
      return meta;
    },
    actionType(): string {
      return this.result?.actionType;
    },
    actionMethod(): string {
      return this.result?.action;
    },
    actionColor(): string {
      return actionColor[this.actionType];
    },
    actionIcon(): string {
      return actionIcon[this.actionMethod];
    },
    stepType(): number {
      return this.result?.type;
    },
    stepColor(): string {
      return stepColor[this.stepType];
    },
    stepBorderColor(): string {
      return this.resultStatus ? stepColor[this.stepType] : statusFailColor;
    },
    resultStatus(): boolean {
      return this.result?.success;
    },
    stepIcon(): string {
      return stepIcon[this.stepType];
    },
  },
  mounted() {
    // console.log(this.result.id, this.last);
    setTimeout(() => {
      if (!this.result.children?.length) {
        scrollToID(this.result.id);
      }
    }, 500);
  },
  components: { Tooltip },
});
</script>
<style scoped>
.pointer {
  cursor: pointer;
}
.step {
  border: 2px solid;
  background-color: #fff !important;
  box-shadow: none;
  min-height: 80px;
  min-width: 350px;
}
.step:hover {
  box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.9);
}
.refChild {
  min-height: 50px;
  height: 50px;
}
.thumbnail,
.prev {
  border: 2px solid rgba(128, 128, 128, 0.43);
  overflow: hidden;
  height: auto;
  max-height: 220px;
  border-radius: 5px;
}
.thumb {
  overflow-y: hidden;
  height: 60px;
}
.prev {
  max-height: 150px;
  position: absolute;
  top: -25px;
  right: -250px;
  width: 250px;
  z-index: 150;
  box-shadow: -5px -5px 0 20px rgba(0, 0, 0, 0.6);
}
.thumbnail .v-image,
.thumb {
  height: 100%;
  position: relative;
  /* border: 2px solid rgba(128, 128, 128, 0.43);
  box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.282); */
}
.thumbnail .block,
.prev .block {
  opacity: 0;
  background: rgba(0, 0, 0, 0.368);
  cursor: pointer;
  transition: opacity 0.5s ease;
}
.prev .block {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  z-index: 100;
}
.thumbnail .block:hover,
.prev .block:hover,
.thumb .block:hover {
  opacity: 1;
}
.thumbnail .block .v-icon,
.prev .block .v-icon,
.thumb .block .v-icon {
  position: absolute;
  top: min(100px, 45%);
  right: 0;
  left: 0;
}
.prev .block .v-icon {
  top: min(75px, 45%);
}
</style>
